export enum FormulaOperationMode {
    ADD_MODE = "ADD_MODE",
    CHOOSE_MODE = "CHOOSE_MODE",
    EDIT_MODE = "EDIT_MODE",
    POP_UP_INFO_MODE = "POP_UP_INFO_MODE"
  }
  